module.exports = __webpack_public_path__ + "static/media/loader-animated.79a7c8c8.gif";